module.exports = __webpack_public_path__ + "static/img/William-Hayes.983ebb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/William-Hayes.jpg
// module id = jBkW
// module chunks = 0